const descriptografarDado = (dado: string) => {

    const KEY = Number(process.env.REACT_APP_SECRET_KEY?.length) || 0

    return atob(dado).split("").map(char => String.fromCharCode(char.charCodeAt(0) ^ KEY)).join("")
}

export default descriptografarDado